import React from "react";
import { useNavigate } from "react-router-dom";
import AnimatedHeadline from "../AnimatedHeadline";
import RevealSection from "../RevealSection";

export const FinalCTA = ({ onOpenAuth }) => {
  const navigate = useNavigate();

  return (
    <section
      id="join"
      data-testid="final-cta-section"
      style={{ padding: "120px 24px", textAlign: "center", background: "white" }}
    >
      <AnimatedHeadline
        text="Your next job deserves better than a guess."
        tag="h2"
        triggerOnView
        className="font-heading"
        style={{
          fontSize: "clamp(32px, 5vw, 52px)",
          fontWeight: 700,
          letterSpacing: "-1px",
          lineHeight: 1.1,
          color: "#1a1a18",
          maxWidth: 700,
          margin: "0 auto",
        }}
      />

      <RevealSection delay={1}>
        <p
          className="font-body"
          style={{
            fontSize: 17,
            color: "#5f5e5a",
            margin: "20px auto 40px",
            maxWidth: 480,
            lineHeight: 1.7,
          }}
        >
          Know the fit. Know the freshness. Know the company. Before you apply.
        </p>
      </RevealSection>

      <RevealSection delay={2}>
        <button
          type="button"
          data-testid="final-cta-primary"
          onClick={() => (onOpenAuth ? onOpenAuth("register") : navigate("/register"))}
          className="cta-pulse font-body"
          style={{
            background: "#1D9E75",
            color: "white",
            padding: "18px 36px",
            borderRadius: 12,
            fontSize: 16,
            fontWeight: 600,
            minHeight: 44,
          }}
        >
          Analyze your first job, it's free →
        </button>
      </RevealSection>

      <p className="font-body" style={{ fontSize: 12, color: "#8a8880", marginTop: 16 }}>
        Built in India. Made for job seekers everywhere.
      </p>
    </section>
  );
};

export default FinalCTA;
